import script from "./personapplydetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./personapplydetail.vue?vue&type=script&setup=true&lang=ts"

import "./personapplydetail.vue?vue&type=style&index=0&id=81feef86&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81feef86"]])

export default __exports__